import { v2Request } from './client';

/** True when coupon has no store restriction or includes the given Firestore store doc id. */
export function isCouponValidForStore(coupon, storeId) {
  const mapping = String(coupon?.storeMapping ?? '').trim();
  if (!mapping) return true;
  const sid = storeId != null ? String(storeId).trim() : '';
  if (!sid) return false;
  const allowed = mapping.split(',').map((s) => s.trim()).filter(Boolean);
  return allowed.includes(sid);
}

/** Client-side filter (fallback if list was fetched without storeId). */
export function filterCouponsForStore(coupons, storeId) {
  if (!Array.isArray(coupons)) return [];
  return coupons.filter((c) => isCouponValidForStore(c, storeId));
}

/**
 * Pilot GET /api/coupons/cccAppFormat — list for customer UI.
 * @param {{ storeId?: string }} [opts] Firestore stores collection document id
 */
export async function listCouponsCccFormat({ storeId } = {}) {
  const sid = storeId != null ? String(storeId).trim() : '';
  const path = sid
    ? `/api/coupons/cccAppFormat?storeId=${encodeURIComponent(sid)}`
    : '/api/coupons/cccAppFormat';
  const data = await v2Request(path);
  const rows = Array.isArray(data?.coupons) ? data.coupons : [];
  return sid ? filterCouponsForStore(rows, sid) : rows;
}

/**
 * Pilot POST /api/coupons/validate-coupon
 * @param {{ mobile: string, code: string, skus: string[], cartTotal: number, storeId?: string }} p
 */
export async function validateCartCoupon({ mobile, code, skus, cartTotal, storeId }) {
  const body = {
    mobile: mobile != null ? String(mobile).trim() : '',
    code: String(code || '').trim(),
    skus: Array.isArray(skus) ? skus : [],
    cartTotal: Number(cartTotal) || 0,
  };
  const sid = storeId != null ? String(storeId).trim() : '';
  if (sid) body.storeId = sid;
  return v2Request('/api/coupons/validate-coupon', {
    method: 'POST',
    body,
  });
}
